import usersRouter        from './users.router';
import usersListModule    from './users-list/users-list';
import usersDetailModule  from './users-detail/users-detail';
import usersUpdateModule  from './users-update/users-update';
import usersCreateModule  from './users-create/users-create';

import usersService       from './users.service';

const usersModule = angular
  .module('users', [
    usersListModule.name,
    usersDetailModule.name,
    usersUpdateModule.name,
    usersCreateModule.name
  ])
  .service('$users', usersService)
  .config( usersRouter );

export default usersModule;


/** WEBPACK FOOTER **
 ** ./frontend/components/admin/users/users.js
 **/